import Button from '@material-ui/core/Button';
import styled from 'styled-components';
export const EditedDivStyle = styled.div`
  display: flex;
  float: left;
  margin-left: 3px;
  font-size: 14px;
  color: #3e3e3e;
`;
export const StyledLogo = styled.img`
  height: 14px;
  width: 14px;
`;
export const EditedDivStyleLabel = styled.div`
  height: 32px;
  max-width: 300px;
  color: #141414;
  font-family: 'OpenSans-Light';
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const StyledButton = styled(Button)`
  &.MuiButton-root {
    padding: 0px !important;
    color: black;
    height: 32px;
    min-width: 0px;
    border-color: #f8f9fa;
    background-color: #ffffff;
    border: 1px solid transparent;
    margin-left: 16px;
  }
  &.MuiButton-contained {
    box-shadow: none !important;
  }

  &.MuiButton-root:hover {
    background-color: #ffffff;
    background: none;
    text-decoration: none;
  }
`;